import React, { ReactNode } from "react";
import Auth from "../common/auth/auth";
import { useSessionManager } from "../hooks/useSessionManager";
import SessionWarningModal from "../components/SessionExp/SessionWarningModal";
// import SessionDevPanel from "../components/SessionExp/SessionDevPanel";

interface SessionProviderProps {
    children: ReactNode;
    auth: Auth;
    enableDevPanel?: boolean;
}

export const SessionProvider: React.FC<SessionProviderProps> = ({
    children,
    auth,
    // enableDevPanel = process.env.NODE_ENV === "local"
}) => {
    const {
        showWarning,
        minutesRemaining,
        isRenewing,
        continueSession,
        logout
    } = useSessionManager({ auth });

    return (
        <>
            {children}
            <SessionWarningModal
                show={showWarning}
                minutesRemaining={minutesRemaining}
                onContinueSession={continueSession}
                onLogout={logout}
                isRenewing={isRenewing}
            />
            {/* THIS IS A SECTION FOR SESSION EXPIRATION TESTS, UNCOMMENT THIS TO GATHER ACCESS TO DEBUG PANEL */}
            {/* <SessionDevPanel auth={auth} enabled={enableDevPanel && process.env.NODE_ENV !== "production"} /> */}
        </>
    );
};

export default SessionProvider;
